function cleanUpCollectionTitle(title) {
    return title
        .toLowerCase()
        .replace(/^men's|^men|^women's|^women/, '')
        .trim();
}
function getCollectionData(root, firstCollection, maxTier) {
    var collectionCollections = root.querySelectorAll('[data-collections][data-tier]');
    var productCollections = root.querySelector('[data-product-collections]');
    var collectionsProductIsPartOf = JSON.parse((productCollections === null || productCollections === void 0 ? void 0 : productCollections.dataset.productCollections) || '[]').map(function (collection) { return collection.handle; });
    var collectionJSON = Array.from(collectionCollections).map(function (group) {
        return {
            tier: parseInt(group.dataset.tier),
            collections: JSON.parse(group.dataset.collections).filter(function (collection) {
                return collectionsProductIsPartOf.includes(collection.handle);
            }),
        };
    });
    return collectionJSON
        .map(function (collectionWrapper) {
        var match = collectionWrapper.collections.find(function (coll) { return coll.handle === firstCollection; });
        if (match && collectionWrapper.tier <= maxTier)
            return { tier: collectionWrapper.tier, collection: match };
    })
        .filter(function (i) { return i; })
        .pop();
}
function handleUnisex(_a) {
    var _b, _c;
    var root = _a.root, crumbElement = _a.crumbElement, collectionsList = _a.collectionsList;
    var lastVisitedCollection = collectionsList
        .filter(function (collection) {
        return collection !== '/collections/all' &&
            collection !== '/collections/accessories-all';
    })
        .pop();
    if (!lastVisitedCollection)
        return;
    var firstCollection = lastVisitedCollection.replace('/collections/', '');
    var firstCollectionData = getCollectionData(root, firstCollection, 3);
    if (!firstCollectionData)
        return;
    var linkClone = crumbElement.cloneNode();
    var caretClone = (_c = (_b = crumbElement.parentNode) === null || _b === void 0 ? void 0 : _b.querySelector('[data-macade-breadcrumb-caret]')) === null || _c === void 0 ? void 0 : _c.cloneNode(true);
    function unisexLink(link, sex) {
        return link.replace(/accessories-all|all/, "".concat(sex, "-accessories"));
    }
    function applyParent(sex) {
        var _a, _b;
        linkClone.textContent = sex;
        linkClone.href = unisexLink(crumbElement.href, sex);
        crumbElement.textContent = cleanUpCollectionTitle(firstCollectionData.collection.title);
        crumbElement.href =
            '/collections/' + firstCollectionData.collection.handle;
        (_a = crumbElement.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(linkClone, crumbElement);
        if (caretClone) {
            (_b = crumbElement.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(caretClone, crumbElement);
        }
    }
    if (firstCollection.includes('women')) {
        applyParent('women');
    }
    else if (firstCollection.includes('men')) {
        applyParent('men');
    }
}
// Runs once per <product-info>: on first load and again each time the colour
// picker swaps the product section in place (which fires product-info:loaded).
// Everything is scoped to `root` because the old and new <product-info> briefly
// coexist in the DOM during a swap.
function initMacadeBreadcrumbs(root) {
    var nav = root.querySelector('.macade-breadcrumbs');
    if (!nav || nav.dataset.initialized)
        return;
    nav.dataset.initialized = 'true';
    var crumbElements = root.querySelectorAll('[data-macade-breadcrumb]');
    try {
        var breadcrumbPath = JSON.parse(localStorage.getItem('breadcrumbPath') || '[]');
        var collectionsList = breadcrumbPath.filter(function (crumb) {
            return crumb.startsWith('/collections/');
        });
        if (crumbElements.length === 1) {
            handleUnisex({ root: root, crumbElement: crumbElements[0], collectionsList: collectionsList });
        }
        else if (collectionsList.length) {
            var firstCollection = collectionsList
                .pop()
                .replace('/collections/', '');
            var collectionData_1 = [];
            var firstCollectionData = getCollectionData(root, firstCollection, 3);
            if (firstCollectionData)
                collectionData_1.push(firstCollectionData);
            if (collectionsList.length && (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.tier) > 1) {
                var secondCollection = collectionsList
                    .pop()
                    .replace('/collections/', '');
                var secondCollectionData = getCollectionData(root, secondCollection, (firstCollectionData === null || firstCollectionData === void 0 ? void 0 : firstCollectionData.tier) - 1);
                if (secondCollectionData)
                    collectionData_1.push(secondCollectionData);
                if (collectionsList.length && (secondCollectionData === null || secondCollectionData === void 0 ? void 0 : secondCollectionData.tier) > 1) {
                    var thirdCollection = collectionsList
                        .pop()
                        .replace('/collections/', '');
                    var thirdCollectionData = getCollectionData(root, thirdCollection, (secondCollectionData === null || secondCollectionData === void 0 ? void 0 : secondCollectionData.tier) - 1);
                    if (thirdCollectionData)
                        collectionData_1.push(thirdCollectionData);
                }
            }
            if (collectionData_1.length) {
                // Check if the latest visited page is tier 2
                var latestVisitedIsTier2 = collectionData_1.some(function (coll) { return coll.tier === 2; });
                if (latestVisitedIsTier2) {
                    collectionData_1.sort(function (a, b) { return b.tier - a.tier; });
                    collectionData_1.forEach(function (coll) {
                        var link = root.querySelector(".macade-breadcrumbs a[data-tier=\"".concat(coll.tier, "\"]"));
                        if (link) {
                            if (coll.tier === 1 && collectionData_1.length !== 1) {
                                link.innerHTML = coll.collection.title
                                    .toLowerCase()
                                    .replace('latest', '')
                                    .trim();
                            }
                            else {
                                link.innerHTML = cleanUpCollectionTitle(coll.collection.title);
                            }
                            link.href = '/collections/' + coll.collection.handle;
                            link.dataset.history = 'true';
                            var caret = root.querySelector(".macade-breadcrumbs span[data-tier=\"".concat(coll.tier, "\"]"));
                            if (caret) {
                                caret.dataset.history = 'true';
                            }
                        }
                    });
                    var toRemove = root.querySelectorAll(".macade-breadcrumbs [data-tier]:not([data-history])");
                    toRemove.forEach(function (entry) { return entry.remove(); });
                }
            }
        }
    }
    catch (error) {
        console.error('error parsing collecion data', error);
    }
}
document.addEventListener('DOMContentLoaded', function () {
    initMacadeBreadcrumbs(document);
});
document.addEventListener('product-info:loaded', function (event) {
    initMacadeBreadcrumbs(event.target);
});
